import { useEffect, useState } from "react";
import Slider from "react-slick";
import AnimatedText from "../../AnimatedText";
import "./AboutPageElementCss/ManagementTeam.css";
import { BsLinkedin } from "react-icons/bs";
import ExpertProfileModal from "./ExpertProfileModal";
import { getmanagementteam } from "../../api/api";

export default function ManagementTeamSection() {
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [managementDetails, setManagementDetails] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);

  // Fetch API data
  useEffect(() => {
    fetchmanagementteam();
  }, []);

  const fetchmanagementteam = async () => {
    try {
      setLoading(true);
      const res = await getmanagementteam({});
      const apiData = res?.data?.data || [];
      if (apiData.length > 0) {
        setManagementDetails(apiData);
        setMessage("");
      } else {
        setManagementDetails([]);
        setMessage("No data found");
      }
    } catch (error) {
      console.error("Error fetching management team data:", error);
      setMessage("Something went wrong while fetching data");
    } finally {
      setLoading(false);
    }
  };

  // Responsive check
  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const mobileSliderSettings = {
    dots: true,
    autoplay: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1.1,
    slidesToScroll: 1,
  };

  // Card Component
  const ExpertCard = ({ expert, index }) => (
    <div
      key={expert.OurManTeamId}
      className={`expert-card ${index % 2 === 1 ? "with-bg" : ""}`}
    >
      <div
        className="expert-image"
        style={{ backgroundImage: `url(${expert.ManImage})` }}
      ></div>
      <div className="expert-info">
        {/* Render ManName as HTML */}
        <h3
          dangerouslySetInnerHTML={{ __html: expert.ManName }}
        />
        {/* Optional LinkedIn (if API provides later) */}
        <div className="social-icons">
          {/* <a href="#" target="_blank" rel="noreferrer">
            <BsLinkedin color="#0A66C2" />
          </a> */}
        </div>
        <button
          className="profile-link"
          onClick={() => setSelectedExpert(expert)}
        >
          View Profile
        </button>
      </div>
    </div>
  );

  return (
    <>
      <div className="managementSection">
        <div className="packageUpperSection">
          <h4 className="rb-headingTag pk-tag">Our Management Team</h4>
          <AnimatedText
            tag="h2"
            type="words"
            y={30}
            className="rb-title pk-title temp"
          >
            Meet the People <br /> Behind Our Progress
          </AnimatedText>
        </div>

        {/* Loading / Error / No Data */}
        {loading && <p>Loading...</p>}
        {!loading && message && <p>{message}</p>}

        {/* Show Data */}
        {!loading && managementDetails.length > 0 && (
          <div className="experts-section">
            {isMobile ? (
              <Slider {...mobileSliderSettings}>
                {managementDetails.map((expert, index) => (
                  <ExpertCard
                    key={expert.OurManTeamId}
                    expert={expert}
                    index={index}
                  />
                ))}
              </Slider>
            ) : (
              <div className="experts-grid">
                {managementDetails.map((expert, index) => (
                  <ExpertCard
                    key={expert.OurManTeamId}
                    expert={expert}
                    index={index}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal with Description */}
      <ExpertProfileModal
        isOpen={!!selectedExpert}
        expert={selectedExpert}
        onClose={() => setSelectedExpert(null)}
      >
        {selectedExpert && (
          <div
            dangerouslySetInnerHTML={{ __html: selectedExpert.ManDesc }}
          />
        )}
      </ExpertProfileModal>
    </>
  );
}
